import { render, staticRenderFns } from "./ConfirmationPromiseDialog.vue?vue&type=template&id=4a49f925&scoped=true"
import script from "./ConfirmationPromiseDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmationPromiseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a49f925",
  null
  
)

export default component.exports